import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class ReAcquisitionHelper {
  
  readonly MIN_QUERY_LENGTH = 9;
  readonly ERROR_MESSAGES = {
    en: {
      EMPTY_RESPONSE: "This field is required — let the doctor know your concern.",
      MIN_LENGTH: "Your message must be at least 10 characters to help the doctor understand your concern."
    },
    hi: {
      EMPTY_RESPONSE: "यह फ़ील्ड आवश्यक है — डॉक्टर को अपनी समस्या बताएं।",
      MIN_LENGTH: "यह फ़ील्ड ज़रूरी है — डॉक्टर को अपनी समस्या बताएं"
    }
  };

  constructor() {}

  validateUserQuery(userQuery: string, userLanguagePreference?: string): { valid: boolean; error: string } {
    const language = userLanguagePreference || 'en';
    const errorMessages = this.ERROR_MESSAGES[language] || this.ERROR_MESSAGES.en;

    if (!userQuery?.length) {
      return { valid: false, error: errorMessages.EMPTY_RESPONSE };
    }
    if (userQuery.length <= this.MIN_QUERY_LENGTH) {
      return { valid: false, error: errorMessages.MIN_LENGTH };
    }
    return { valid: true, error: '' };
  }
}